<template>
  <div class="sect-section">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="sect-title">{{ sectInfo.name }}</h1>
          <p class="lead text-center mb-5" style="color: #e9ecef;">
            {{ sectInfo.summary }}
          </p>
        </div>
      </div>

      <!-- Navegação por Seções -->
      <div class="section-nav mb-3">
        <ul class="nav nav-pills justify-content-center flex-wrap gap-2">
          <li class="nav-item"><a :class="['nav-link', { active: activeSection==='politics' }]" href="#politics" @click.prevent="navigateTo('politics')">Política</a></li>
          <li class="nav-item"><a :class="['nav-link', { active: activeSection==='influences' }]" href="#influences" @click.prevent="navigateTo('influences')">Influências</a></li>
          <li class="nav-item"><a :class="['nav-link', { active: activeSection==='ethos' }]" href="#ethos" @click.prevent="navigateTo('ethos')">Ethos</a></li>
          <li class="nav-item"><a :class="['nav-link', { active: activeSection==='relationships' }]" href="#relationships" @click.prevent="navigateTo('relationships')">Relações</a></li>
          <li class="nav-item" v-if="sectInfo.laws?.length"><a :class="['nav-link', { active: activeSection==='laws' }]" href="#laws" @click.prevent="navigateTo('laws')">Leis</a></li>
          <li class="nav-item" v-if="sectInfo.roles?.length"><a :class="['nav-link', { active: activeSection==='roles' }]" href="#roles" @click.prevent="navigateTo('roles')">Cargos</a></li>
          <li class="nav-item" v-if="sectInfo.rituals?.length"><a :class="['nav-link', { active: activeSection==='rituals' }]" href="#rituals" @click.prevent="navigateTo('rituals')">Rituais</a></li>
          <li class="nav-item"><a :class="['nav-link', { active: activeSection==='practices' }]" href="#practices" @click.prevent="navigateTo('practices')">Práticas</a></li>
        </ul>
      </div>

      <div class="row g-4">
        <div id="politics" class="col-md-6 anchor-section">
          <div class="card" style="background: var(--vampire-gray); border: 1px solid var(--vampire-red);">
            <div class="card-body">
              <h5 class="card-title" style="color: var(--vampire-gold);">
                <i class="bi bi-diagram-3 me-2"></i>
                Política e Hierarquia
              </h5>
              <p class="mb-2"><strong>Hierarquia:</strong> {{ sectInfo.politics.hierarchy }}</p>
              <p class="mb-0"><strong>Princípios:</strong> {{ sectInfo.politics.tenets }}</p>
            </div>
          </div>
        </div>

        <div id="influences" class="col-md-6 anchor-section">
          <div class="card" style="background: var(--vampire-gray); border: 1px solid var(--vampire-red);">
            <div class="card-body">
              <h5 class="card-title" style="color: var(--vampire-gold);">
                <i class="bi bi-broadcast-pin me-2"></i>
                Influências
              </h5>
              <p class="mb-0">{{ sectInfo.influences }}</p>
            </div>
          </div>
        </div>

        <div id="ethos" class="col-md-6 anchor-section">
          <div class="card" style="background: var(--vampire-gray); border: 1px solid var(--vampire-red);">
            <div class="card-body">
              <h5 class="card-title" style="color: var(--vampire-gold);">
                <i class="bi bi-compass me-2"></i>
                Ethos
              </h5>
              <p class="mb-0">{{ sectInfo.ethos }}</p>
            </div>
          </div>
        </div>

        <div id="relationships" class="col-md-6 anchor-section">
          <div class="card" style="background: var(--vampire-gray); border: 1px solid var(--vampire-red);">
            <div class="card-body">
              <h5 class="card-title" style="color: var(--vampire-gold);">
                <i class="bi bi-people me-2"></i>
                Relações
              </h5>
              <p class="mb-0">{{ sectInfo.relationships }}</p>
            </div>
          </div>
        </div>

        <!-- Acordeão: Leis, Cargos, Rituais, Práticas -->
        <div class="col-12">
          <div class="accordion" id="sectAccordion">
            <!-- Leis -->
            <div id="laws" class="accordion-item anchor-section" v-if="sectInfo.laws && sectInfo.laws.length">
              <h2 class="accordion-header" id="heading-laws">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-laws" aria-expanded="false" aria-controls="collapse-laws">
                  <i class="bi bi-shield-lock me-2"></i>
                  Leis e Tradições
                </button>
              </h2>
              <div id="collapse-laws" class="accordion-collapse collapse" aria-labelledby="heading-laws" data-bs-parent="#sectAccordion">
                <div class="accordion-body" style="color: black;">
                  <ul class="mb-0" style="padding-left: 1.1rem;">
                    <li v-for="(law, idx) in sectInfo.laws" :key="'law-'+idx">{{ law }}</li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Cargos -->
            <div id="roles" class="accordion-item anchor-section" v-if="sectInfo.roles && sectInfo.roles.length">
              <h2 class="accordion-header" id="heading-roles">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-roles" aria-expanded="false" aria-controls="collapse-roles">
                  <i class="bi bi-person-badge me-2"></i>
                  Cargos e Funções
                </button>
              </h2>
              <div id="collapse-roles" class="accordion-collapse collapse" aria-labelledby="heading-roles" data-bs-parent="#sectAccordion">
                <div class="accordion-body">
                  <ul class="mb-0" style="padding-left: 1.1rem;">
                    <li v-for="role in sectInfo.roles" :key="role.title">
                      <strong>{{ role.title }}:</strong> {{ role.description }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Rituais -->
            <div id="rituals" class="accordion-item anchor-section" v-if="sectInfo.rituals && sectInfo.rituals?.length || sectInfo.rituals && sectInfo.rituals.length">
              <h2 class="accordion-header" id="heading-rituals">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-rituals" aria-expanded="false" aria-controls="collapse-rituals">
                  <i class="bi bi-candle me-2"></i>
                  Rituais e Costumes
                </button>
              </h2>
              <div id="collapse-rituals" class="accordion-collapse collapse" aria-labelledby="heading-rituals" data-bs-parent="#sectAccordion">
                <div class="accordion-body">
                  <ul class="mb-0" style="padding-left: 1.1rem;">
                    <li v-for="(ritual, idx) in sectInfo.rituals" :key="'ritual-'+idx">{{ ritual }}</li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Práticas -->
            <div id="practices" class="accordion-item anchor-section">
              <h2 class="accordion-header" id="heading-practices">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-practices" aria-expanded="false" aria-controls="collapse-practices">
                  <i class="bi bi-journal-text me-2"></i>
                  Práticas Notáveis
                </button>
              </h2>
              <div id="collapse-practices" class="accordion-collapse collapse" aria-labelledby="heading-practices" data-bs-parent="#sectAccordion">
                <div class="accordion-body">
                  <p class="mb-0">{{ sectInfo.notablePractices }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 d-flex flex-wrap gap-2 justify-content-center">
          <button class="btn btn-vampire" @click="$emit('view-clans', sect)">
            <i class="bi bi-people-fill me-2"></i>
            Ver Clãs da {{ sectInfo.name }}
          </button>
          <button class="btn btn-secondary" style="background: var(--vampire-light-gray); border: 1px solid var(--vampire-red); color: #f8f9fa;" @click="$emit('go-back')">
            <i class="bi bi-arrow-left me-2"></i>
            Voltar ao Início
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sectsData } from '../data/sects.js'

export default {
  name: 'SectInfoView',
  props: {
    sect: { type: String, required: true }
  },
  data() {
    return {
      activeSection: 'politics',
      collapseHandlers: []
    }
  },
  mounted() {
   
    const openFromHash = () => {
      const id = (window.location.hash || '').replace('#', '')
      if (id) {
        this.openSection(id)
        this.activeSection = id
        const el = document.getElementById(id)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }
    }
    openFromHash()
    this.onHashChange = openFromHash
    window.addEventListener('hashchange', this.onHashChange)

   
    const pairs = [
      { id: 'laws', collapseId: 'collapse-laws' },
      { id: 'roles', collapseId: 'collapse-roles' },
      { id: 'rituals', collapseId: 'collapse-rituals' },
      { id: 'practices', collapseId: 'collapse-practices' }
    ]
    pairs.forEach(({ id, collapseId }) => {
      const el = document.getElementById(collapseId)
      if (!el) return
      const onShow = () => { this.activeSection = id }
      el.addEventListener('show.bs.collapse', onShow)
      this.collapseHandlers.push({ el, onShow })
    })
  },
  beforeUnmount() {
    if (this.onHashChange) {
      window.removeEventListener('hashchange', this.onHashChange)
    }
    if (this.collapseHandlers?.length) {
      this.collapseHandlers.forEach(({ el, onShow }) => {
        el.removeEventListener('show.bs.collapse', onShow)
      })
    }
  },
  computed: {
    sectInfo() {
      return sectsData[this.sect] || { name: 'Seita Desconhecida', summary: '', politics: { hierarchy: '', tenets: '' }, influences: '', ethos: '', relationships: '', notablePractices: '' }
    }
  },
  methods: {
    openSection(id) {
      const collapseEl = document.getElementById(`collapse-${id}`)
      const button = document.querySelector(`[data-bs-target="#collapse-${id}"]`)
      if (collapseEl && !collapseEl.classList.contains('show')) {
        collapseEl.classList.add('show')
      }
      if (button) {
        button.classList.remove('collapsed')
        button.setAttribute('aria-expanded', 'true')
      }
    },
    navigateTo(id) {
      this.activeSection = id
      this.openSection(id)
      this.$nextTick(() => {
        const el = document.getElementById(id)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
        window.location.hash = id
      })
    }
  }
}
</script>

<style scoped>
.card .card-title {
  margin-bottom: .5rem;
}

.accordion-body {
  color: black;
}

.section-nav {
  position: sticky;
  top: 70px; /* abaixo da navbar fixa */
  z-index: 1;
  background: linear-gradient(135deg, rgba(26,13,13,0.6) 0%, rgba(44,44,44,0.6) 100%);
  backdrop-filter: blur(4px);
  padding: .5rem 0;
  border-bottom: 1px solid var(--vampire-red);
}

.section-nav .nav-link {
  border: 1px solid var(--vampire-red);
  color: #f8f9fa;
}
.section-nav .nav-link:hover, .section-nav .nav-link:focus {
  color: #f8f9fa;
  background: var(--vampire-red);
}

.anchor-section { scroll-margin-top: 100px; }
</style>
